import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Award } from "lucide-react";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

interface UserBadge {
  badges: {
    id: string;
    name: string;
    description: string;
    icon_url: string;
  };
}

export const BadgesCard = () => {
  const { user } = useAuth();
  const [badges, setBadges] = useState<UserBadge[]>([]);

  useEffect(() => {
    if (user) {
      loadBadges();
    }
  }, [user]);

  const loadBadges = async () => {
    if (!user) return;

    const { data } = await supabase
      .from('user_badges')
      .select('badges(*)')
      .eq('user_id', user.id)
      .limit(6);

    if (data) {
      setBadges(data as UserBadge[]);
    }
  };

  return (
    <Card className="clean-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Award className="h-5 w-5 text-primary" />
          My Badges
        </CardTitle>
      </CardHeader>
      <CardContent>
        {badges.length > 0 ? (
          <div className="grid grid-cols-3 gap-3">
            {badges.map((userBadge) => (
              <div
                key={userBadge.badges.id}
                className="flex flex-col items-center gap-2 p-3 rounded-lg bg-muted/50 hover:bg-muted transition-colors"
              >
                {userBadge.badges.icon_url ? (
                  <img 
                    src={userBadge.badges.icon_url} 
                    alt={userBadge.badges.name}
                    className="h-8 w-8"
                  />
                ) : (
                  <Award className="h-8 w-8 text-primary" />
                )}
                <span className="text-xs font-medium text-center line-clamp-1">
                  {userBadge.badges.name}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-sm text-muted-foreground">
            <Award className="h-12 w-12 mx-auto mb-2 opacity-20" />
            <p>No badges yet</p>
            <p className="text-xs">Engage with streams to earn badges!</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
